import { Card, ViewPdf } from '@/components/ui';
import { ProductionApi } from '@/state/api';
import { Flex, Text } from '@chakra-ui/react';
import { skipToken } from '@reduxjs/toolkit/query';

type FramePreviewType = {
  frameId: number | undefined;
};

type FrameDetailWrappedResponse = {
  code: string;
  message: string;
  data?: {
    id: number;
    name: string;
    quantity: number;
    project_id: number;
    release_id: number;
    frame_masterfile_id: number | null;
    frame_masterfile_revision_id: number | null;
    frame_drawing_url: string | null;
    parts: {
      part_id: number;
      part_number: string;
      attributes?: Record<string, unknown>;
      required_per_frame: number;
      required_total: number;
      available_qty: number;
      short_qty: number;
    }[];
    work_orders: unknown[];
    history: unknown[];
    created_at: string;
    updated_at: string;
  };
};

const FramePreview = ({ frameId }: FramePreviewType) => {
  const { data: frameResponse, isLoading } = ProductionApi.Api.useGetFrameQuery(
    frameId
      ? {
          params: {
            id: frameId,
          },
        }
      : skipToken,
  );

  const frameData = frameResponse as FrameDetailWrappedResponse | undefined;
  const frame = frameData?.data;

  return (
    <Flex flexDirection="column" rounded="sm" overflow="hidden">
      <Flex
        flexDirection="column"
        bg="gray.700"
        color="white"
        paddingX={4}
        paddingY={2}
      >
        <Text fontWeight="bold" color="white">
          Frame Preview
        </Text>
        <Text fontSize="xs" color="whiteAlpha.800">
          Select a frame to view drawing and summary
        </Text>
      </Flex>

      <Card borderRadius={0}>
        <ViewPdf
          key={`frame-preview-${frameId}-${frame?.frame_drawing_url ?? 'none'}`}
          url={frame?.frame_drawing_url ?? ''}
          pdfTitle={frame?.name ?? 'Document'}
          pageTitle="Frame Preview"
          details={[
            {
              label: 'Frame',
              value: frame?.name ?? '',
            },
            {
              label: 'Quantity',
              value: frame?.quantity ?? '',
            },
            {
              label: 'Parts',
              value: frame?.parts?.length ?? '',
            },
            {
              label: 'Drawing',
              value: frame?.frame_drawing_url ? 'Available' : 'No File',
            },
          ]}
          isDisabled={!frame?.frame_drawing_url || isLoading}
          showOpenTabButton={true}
        />
      </Card>
    </Flex>
  );
};

export default FramePreview;